import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/FrontendLp'

const FrontendLp: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={
          'SPA ReactJS フロントエンド開発 コンポーネント開発 GraphQL WebSocket Next.js TypeScript Atomic Design '
        }
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/frontend-dev/'}
        title="フロントエンド開発 | Aitria（アイトリア）"
        description="Aitria（アイトリア）では、UIデザインとフロントエンド開発の双方の考え方を理解したデザイナーとエンジニアがチームを組んでいます。最新のフロントエンド技術を駆使して、一緒にWebサイトを開発しましょう。"
      />
      <Template />
    </>
  )
}

export default FrontendLp
